// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_qp-5";
export var filledCircle = "_qp-4";
export var historyEntry = "_qp-3";
export var messageSideLeft = "_qp-1";
export var messageSideRight = "_qp-2";
export var orderTrackingCarouselWrapper = "_qp-6";
export var orderTrackingInfoContainer = "_qp-0";